export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-date-lead.vue?vue&type=template&id=453bb0a0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-date-lead/lk-date-lead.vue?vue&type=template&id=453bb0a0&
// module id = 1439
// module chunks = 0